<template>
  <div class="routing-detail-truck">
    <div class="title custom-title">Routing Details</div>
    <validation-observer name="Routing" ref="validateRouting">
      <b-card class="b-card-bg">
        <b-row class="px-2">
          <b-col cols="12" lg="4">
            <validation-provider
              name="Quotation No."
              #default="{ errors }"
              rules=""
            >
              <b-form-group>
                <label>Quotation No.</label>
                <Select4
                  :disabled="readonly"
                  class="select2-v2"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                  placeholder="Quotation No."
                  v-model="value.quotation"
                  :options="{
                    isSearch: true,
                    value: 'id',
                    label: 'id',
                    data: quotations,
                    fields: [
                      {
                        field: 'id',
                        label: 'Quotation No.',
                      },
                      {
                        field: 'exp_date',
                        label: 'Valid to',
                      },
                      {
                        field: 'total_cost',
                        label: 'Total cost',
                      },
                    ],
                  }"
                />

                <small class="text-danger" v-show="errors.length > 0">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <b-col lg="2"></b-col>
          <b-col lg="4"
            ><validation-provider
              name="Handling type"
              #default="{ errors }"
              rules="required"
            >
              <b-form-group>
                <label class="flex"
                  >Handling type
                  <div class="red">*</div>
                </label>
                <Select4
                  :disabled="readonly"
                  class="select2-v2"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                  placeholder="Select Handling type"
                  v-model="value.shippingType"

                  @select="()=> {
                    value.pickup_location = '';
                    value.delivery_location = '';
                  }"
                  
                  :options="{
                    value: 'id',
                    label: 'name',
                    data: transport_types,
                    fields: [
                      {
                        field: 'name',
                        label: 'Type',
                      },
                    ],
                  }"
                />

                <small class="text-danger" v-show="errors.length > 0">{{
                  errors[0]
                }}</small>
              </b-form-group>
            </validation-provider></b-col
          >
        </b-row>
        <b-row class="px-2 mt-1">
          <b-col>
            <b-row>
              <b-col lg="10">
                <validation-provider
                  name="Pick up address"
                  #default="{ errors }"
                  rules="required"
                  v-if="!value.isPickUpInput"
                >
                  <b-form-group>
                    <label class="flex"
                      >Pick up address
                      <span class="red">*</span>
                    </label>

                    <Select4
                      :key="locationPickUp"
                      v-model="value.pickup_location"
                      placeholder="Enter a previously used pick up address, or click OTHER to in put a new one"
                      :disabled="readonly"
                      @reload="loadLocation"

                      :options="{
                        isSearch: true,
                        isReload: true,

                        value: 'id',
                        label: 'text',
                        data: locationPickUp,
                        fields: [
                          {
                            field: 'abbreviations',
                            label: 'Abbreviations',
                          },
                          {
                            field: 'name',
                            label: 'Location',
                          },
                          {
                            field: 'address',
                            label: 'Address',
                          },
                        ],
                      }"
                    />
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
                <validation-provider
                  name="Pick up address"
                  #default="{ errors }"
                  rules="required"
                  v-if="value.isPickUpInput"
                >
                  <b-form-group>
                    <label class="flex"
                      >Pick up address

                      <span class="red">*</span>
                    </label>

                    <b-form-input
                      :disabled="readonly"
                      class="iuput"
                      v-model="value.valuePickupInput"
                      type="text"
                      placeholder="Enter a previously used pick up address, or click OTHER to in put a new one"
                    ></b-form-input>
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col lg="2">
                <div class="container-checkbox">
                  <input
                    :disabled="readonly"
                    type="checkbox"
                    class="custom-checkbox-new"
                    v-model="value.isPickUpInput"
                  />

                  <div>
                    <div class="text-black">Other</div>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-col>
          <b-col>
            <b-row>
              <b-col lg="10">
                <validation-provider
                  name="Delivery address"
                  #default="{ errors }"
                  rules="required"
                  v-if="!value.isAddressInput"
                >
                  <b-form-group>
                    <label class="flex"
                      >Delivery address
                      <span class="red">*</span>
                    </label>

                    <Select4
                      :key="locationDelivery"
                      v-model="value.delivery_location"
                      placeholder="Enter a previously used delivery address, or click OTHER to in put a new one"
                      :disabled="readonly"
                      @reload="loadLocation"

                      :options="{
                        isSearch: true,
                        isReload: true,

                        value: 'id',
                        label: 'text',
                        data: locationDelivery,
                        fields: [
                          {
                            field: 'abbreviations',
                            label: 'Abbreviations',
                          },
                          {
                            field: 'name',
                            label: 'Location',
                          },
                          {
                            field: 'address',
                            label: 'Address',
                          },
                        ],
                      }"
                    />
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
                <validation-provider
                  name="Delivery address"
                  #default="{ errors }"
                  rules="required"
                  v-if="value.isAddressInput"
                >
                  <b-form-group>
                    <label class="flex"
                      >Delivery address <span class="red">*</span></label
                    >

                    <b-form-input
                      :disabled="readonly"
                      class="iuput"
                      v-model="value.valueAddressInput"
                      type="text"
                      placeholder="Enter a previously used delivery address, or click OTHER to in put a new one"
                    ></b-form-input>
                    <small class="text-danger" v-show="errors.length > 0">{{
                      errors[0]
                    }}</small>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col lg="2">
                <div class="container-checkbox">
                  <input
                    :disabled="readonly"
                    type="checkbox"
                    class="custom-checkbox-new"
                    v-model="value.isAddressInput"
                  />

                  <div>
                    <div class="text-black">Other</div>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="px-2 mt-1">
          <b-col lg="4">
            <b-row class="px-1"><label>Pick up contact person</label></b-row>
            <b-row>
              <b-col class="pr-0">
                <b-form-input
                  :disabled="readonly"
                  class="iuput"
                  v-model="value.pickUpContact.name"
                  type="text"
                  placeholder="Name"
                ></b-form-input>
              </b-col>
              <b-col>
                <b-form-input
                  :disabled="readonly"
                  class="iuput"
                  v-model="value.pickUpContact.phone"
                  type="text"
                  placeholder="phone"
                ></b-form-input>
              </b-col>
            </b-row>
          </b-col>
          <b-col lg="2"></b-col>
          <b-col lg="4">
            <b-row class="px-1">
              <label>Delivery contact person</label>
            </b-row>
            <b-row>
              <b-col class="pr-0">
                <b-form-input
                  :disabled="readonly"
                  class="iuput"
                  v-model="value.deliveryContact.name"
                  type="text"
                  placeholder="Name"
                ></b-form-input>
              </b-col>
              <b-col>
                <b-form-input
                  :disabled="readonly"
                  class="iuput"
                  v-model="value.deliveryContact.phone"
                  type="text"
                  placeholder="Phone"
                ></b-form-input>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="px-2 mt-2">
          <b-col lg="4">
            <label>Pick up date</label>
            <b-row>
              <b-col class="pr-0">
                <date-picker
                  :disabled="readonly"
                  ref="datePicker"
                  v-model="value.pickUpDate"
                  type="date"
                  title-format="DD/MM/YY"
                  time-title-format="DD/MM/YY"
                  placeholder="Select date"
                  format="DD/MM/YY"
                  class="w-full"
                  value-type="format"
                >
                </date-picker>
              </b-col>
              <b-col>
                <date-picker
                  :disabled="readonly"
                  v-model="value.pickUpTime"
                  ref="datePicker"
                  type="time"
                  title-format="HH:mm"
                  time-title-format="HH:mm"
                  placeholder="Select time"
                  format="HH:mm"
                  class="w-full"
                  value-type="format"
                >
                </date-picker>
              </b-col>
            </b-row>
          </b-col>
          <b-col lg="2"></b-col>
          <b-col lg="4">
            <label>Delivery date</label>
            <b-row>
              <b-col class="pr-0">
                <date-picker
                  :disabled="readonly"
                  ref="datePicker"
                  v-model="value.deliveryDate"
                  type="date"
                  title-format="DD/MM/YY"
                  time-title-format="DD/MM/YY"
                  placeholder="Select date"
                  format="DD/MM/YY"
                  class="w-full"
                  value-type="format"
                >
                </date-picker>
              </b-col>
              <b-col>
                <date-picker
                  :disabled="readonly"
                  v-model="value.deliveryTime"
                  ref="datePicker"
                  type="time"
                  title-format="HH:mm"
                  time-title-format="HH:mm"
                  placeholder="Select time"
                  format="HH:mm"
                  class="w-full"
                  value-type="format"
                >
                </date-picker>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card>
    </validation-observer>
  </div>
</template>

<script>
import Select2 from "v-select2-component";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";
import {
  BButton,
  BFormGroup,
  BInputGroup,
  BInputGroupAppend,
  BInputGroupPrepend,
  BFormDatepicker,
  BRow,
  BCol,
  BTable,
  BCard,
} from "bootstrap-vue";
export default {
  components: {
    BButton,
    ValidationProvider,
    ValidationObserver,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BInputGroupPrepend,
    BFormDatepicker,
    BRow,
    BCol,
    BTable,
    BCard,
    Select2,
  },
  data() {
    return {
      check_country_pick_up: null,
      check_country_delivery: null,
    };
  },
  props: {
    value: {
      type: Object,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    if(this.value.shippingType){
      this.loadLocation();
    }

  },
  computed: {
    ...mapState("masterData", [
      "service_types",
      "ports",
      "incoterms",
      "cont_types",
      "goods_types",
      "transport_types",
      "deports_locations",
      "deports",
      "business_types",
      "customs_types",
      "shipping_lines",
      "regions",
      "companyItems",
      "fee_types",
      "handed_types",
      "quotations",
      "locationPickUp",
      "locationDelivery",
    ]),
  },
  watch: {
    "value.delivery_location": function (n, o) {
      this.valuePerson_delivery = this.locations.filter(
        (item) => item.id === n
      )[0];

      this.value.deliveryContact.name = this.valuePerson_delivery.contact_name;
      this.value.deliveryContact.phone =
        this.valuePerson_delivery.contact_phone;
    },
    "value.pickup_location": function (n, o) {
      this.valuePerson_pick_up = this.locations.filter(
        (item) => item.id === n
      )[0];
      if (this.valuePerson_pick_up && this.valuePerson_pick_up.contact_name) {
        this.value.pickUpContact.name = this.valuePerson_pick_up.contact_name;
      }

      if (this.valuePerson_pick_up && this.valuePerson_pick_up.contact_phone) {
        this.value.pickUpContact.phone = this.valuePerson_pick_up.contact_phone;
      }
    },

   
    "value.customer_id": function (n, o) {
      if (!n) {
        this.$store.commit(
          "masterData/FETCH_LOCATION_USER_HANDLING_TYPE_LOCATION_TYPE_PICK_UP",
          []
        );
        this.$store.commit(
          "masterData/FETCH_LOCATION_USER_HANDLING_TYPE_LOCATION_TYPE_DELIVERY",
          []
        );

        this.value.pickup_location = "";
        this.value.delivery_location = "";
        



      } else {
        if (this.value.shippingType) {
          this.loadLocation();
        }
      }
    },

    "value.shippingType": function (n, o) {
      if (!this.value.customer_id) {
        this.$store.commit(
          "masterData/FETCH_LOCATION_USER_HANDLING_TYPE_LOCATION_TYPE_PICK_UP",
          []
        );
        this.$store.commit(
          "masterData/FETCH_LOCATION_USER_HANDLING_TYPE_LOCATION_TYPE_DELIVERY",
          []
        );

        return;
      }

      this.loadLocation();
    },
  },
  methods: {
    loadLocation() {

      if (!this.value.shippingType) {
        return;
      }


      var type = {
        1: "IMPORT",
        2: "EXPORT",
        3: "PORT_TRANSFER",
        4: "ANOTHER_WAREHOUSE",
      };

      // 1 :IMPORT 2: EXPORT 3: PORT_TRANSFER 4: ANOTHER_WAREHOUSE
      this.$store.dispatch(
        "masterData/fetchLocationByUserHandlingTypeLocationTypePickUp",
        {
          customer_id: this.value.customer_id,
          handling_type_id: type[this.value.shippingType],
          location_type: "PICK_UP",
          tax_code: this.value.company_id,

        }
      );
      this.$store.dispatch(
        "masterData/fetchLocationByUserHandlingTypeLocationTypePickUp",
        {
          customer_id: this.value.customer_id,
          handling_type_id: type[this.value.shippingType],
          location_type: "DELIVERY",
          tax_code: this.value.company_id,

        }
      );
    },
  },
};
</script>

<style lang="scss">
.routing-detail-truck {
  .custom-title {
    align-items: center;
    display: flex;
    height: 43px;
  }

  .container-checkbox {
    display: flex;
    margin-top: 29px;
    align-items: center;
    gap: 5px;
  }

  label {
    color: #000000;
    font-weight: 600;
  }

  .form-control {
    border: 0 !important;
  }

  .b-card-bg {
    height: 500px;

    @media (max-width: 992px) {
      height: 350px;
    }

    .mx-input {
      border: none !important;
    }
  }
}
</style>
